var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.5 62",
    style: {
      enableBackground: "new 0 0 54.5 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,30.7c3.8,2.4,8.4,2.7,12.6,0.7c0.9-0.4,1.3-1.5,0.9-2.4c-0.4-0.9-1.5-1.3-2.4-0.9 c-3.1,1.4-6.5,1.3-9.2-0.4c-2.6-1.7-4.2-4.5-4.2-7.7c0-5,4.1-9.1,9.1-9.1c5,0,9.1,4.1,9.1,9.1c0,1-0.8,1.8-1.8,1.8 c-0.9,0-1.8-0.7-1.8-1.8c0,0,0,0,0,0c0-3-2.4-5.4-5.4-5.4c-3,0-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4c1.4,0,2.7-0.5,3.6-1.4 c1,0.9,2.2,1.4,3.6,1.4c3,0,5.4-2.4,5.4-5.4c0-7-5.7-12.7-12.7-12.7c-7,0-12.7,5.7-12.7,12.7C14.5,24.3,16.7,28.3,20.4,30.7z  M27.2,21.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8c0.9,0,1.7,0.7,1.8,1.6c0,0.2,0,0.3,0,0.5C28.9,21.1,28.1,21.8,27.2,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.5,23.8c0-0.5-0.2-0.9-0.5-1.3l-6.7-6.7v-14c0-1-0.8-1.8-1.8-1.8H9.1c-1,0-1.8,0.8-1.8,1.8v14l-6.7,6.7 c0,0,0,0,0,0C0.2,22.9,0,23.4,0,23.8c0,0,0,0,0,0v32.7c0,3,2.4,5.4,5.4,5.4H49c3,0,5.4-2.4,5.4-5.4L54.5,23.8 C54.5,23.8,54.5,23.8,54.5,23.8z M50.1,23.8l-2.9,2.9V21L50.1,23.8z M43.6,3.6v13c0,0,0,0,0,0v13.8l-9.8,9.8h-13l-9.8-9.8V16.6 c0,0,0,0,0,0v-13H43.6z M7.3,26.7l-2.9-2.9L7.3,21V26.7z M3.6,55.8V28.2L17.4,42L3.6,55.8z M6.2,58.4l14.5-14.5h13l14.5,14.5H6.2z  M50.8,55.8L37.1,42l13.8-13.8V55.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.928ac4358633d2d5974e193726f59715.svg";
export { ForwardRef as ReactComponent };